var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      ref: "select",
      attrs: { placeholder: _vm.placeholder },
      domProps: { value: _vm.value },
      on: {
        change: function($event) {
          _vm.update()
        }
      }
    },
    [
      _vm.defaultValue
        ? _c("option", { attrs: { value: "" } }, [
            _vm._v(_vm._s(_vm.defaultValue))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function(option) {
        return _c(
          "option",
          {
            domProps: {
              value: option.value,
              selected: _vm.value == option.value
            }
          },
          [_vm._v(_vm._s(option.text))]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4943cb5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4943cb5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./www/js/Components/VueSelect/VueSelect.vue
// module id = 492
// module chunks = 2